import { render, staticRenderFns } from "./CarManage.vue?vue&type=template&id=e164de7e&"
import script from "./CarManage.vue?vue&type=script&lang=js&"
export * from "./CarManage.vue?vue&type=script&lang=js&"
import style0 from "./CarManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports